import { head } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getSelectedEnterpriseIntroImageId } from '../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ServerImage } from '../service';

const BaseRoomImage = ({ imageIds, fallbackImageId, ...other }: $TSFixMe) => (
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    <ServerImage id={head(imageIds) || fallbackImageId} {...other} />
);

export const RoomImage = connect(
    createStructuredSelector({
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        fallbackImageId: getSelectedEnterpriseIntroImageId,
    })
)(BaseRoomImage);
